"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var isGlobalEnvEnabled = function isGlobalEnvEnabled(_ref) {
  var globalEnv = _ref.globalEnv,
    language = _ref.language,
    _ref$returnValue = _ref.returnValue,
    returnValue = _ref$returnValue === void 0 ? false : _ref$returnValue;
  if ((globalEnv === null || globalEnv === void 0 ? void 0 : globalEnv[language === null || language === void 0 ? void 0 : language.language]) === undefined) {
    return false;
  }
  var globalValue = parseInt(globalEnv === null || globalEnv === void 0 ? void 0 : globalEnv[language === null || language === void 0 ? void 0 : language.language]);
  return returnValue ? globalValue : Boolean(globalValue);
};
var _default = isGlobalEnvEnabled;
exports["default"] = _default;